import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import type { Category } from '@photobooth/types';

export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await api.categories.getAll();
      if (response.success && response.data) {
        // Handle nested data structure from API client
        const categoriesData = (response.data as any).data || response.data;
        setCategories(Array.isArray(categoriesData) ? categoriesData : []);
      } else {
        setError('Failed to fetch categories');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch categories');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return {
    categories,
    isLoading,
    error,
    refetch: fetchCategories,
  };
}
